import { Unstable_Grid2 as Grid, Typography } from '@mui/material';

import { SelectAutocomplete } from '@occc-app/design-system';

import { monthOptions } from './constants';
import { AudienceFormValuesPaths } from '../../types';

export const BirthdayFormContent = () => {
  return (
    <div>
      <Typography paragraph variant='subtitle1'>
        Birthday
      </Typography>
      <Grid container spacing={3}>
        <Grid xs={12} sm={6} md={4}>
          <SelectAutocomplete<AudienceFormValuesPaths>
            name='birthdayMonths'
            label='Months'
            placeholder='Select months'
            options={monthOptions}
          />
        </Grid>
      </Grid>
    </div>
  );
};
